import { render, staticRenderFns } from "./ondemand.vue?vue&type=template&id=33ebfa8c&scoped=true&"
import script from "./ondemand.vue?vue&type=script&lang=js&"
export * from "./ondemand.vue?vue&type=script&lang=js&"
import style0 from "./ondemand.vue?vue&type=style&index=0&id=33ebfa8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ebfa8c",
  null
  
)

export default component.exports